export const Footer = ({ scrollToSection }) => (
  <footer className="footer" data-testid="footer">
    <div className="footer-brand" data-testid="footer-brand">
      Vartalab
    </div>
    <div className="footer-text" data-testid="footer-text">
      Communications and brand growth partner for leaders, students and
      independent professionals.
    </div>
    <div className="footer-links" data-testid="footer-links">
      <button
        className="footer-link"
        onClick={() => scrollToSection("leaders")}
        data-testid="footer-leaders-link"
      >
        Leaders
      </button>
      <button
        className="footer-link"
        onClick={() => scrollToSection("students")}
        data-testid="footer-students-link"
      >
        Students
      </button>
      <button
        className="footer-link"
        onClick={() => scrollToSection("professionals")}
        data-testid="footer-professionals-link"
      >
        Professionals
      </button>
      <button
        className="footer-link"
        onClick={() => scrollToSection("team")}
        data-testid="footer-team-link"
      >
        Team
      </button>
      <button
        className="footer-link"
        onClick={() => scrollToSection("contact")}
        data-testid="footer-contact-link"
      >
        Contact
      </button>
    </div>
  </footer>
);
